export const getSelectedRightOptionsItem = (state) => state.header.get('selectedRightOptionsItem');

export const isRightOptionsItemSelected = (state, menuName) => state.header?.get('selectedRightOptionsItem') === menuName;
